var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInformational(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1369 0C9.68367 0 10.2304 0 10.7772 0C10.8099 0.0130684 10.8419 0.0326711 10.8767 0.0377533C11.2238 0.0893011 11.5738 0.122698 11.918 0.189493C17.3756 1.25602 20.9271 6.59812 19.7885 12.023C18.4713 18.3009 11.666 21.7735 5.85697 19.0778C2.61262 17.5734 0.707977 14.9881 0.10892 11.4545C0.072613 11.241 0.0363065 11.0276 0 10.8149C0 10.2551 0 9.69534 0 9.1363C0.0145226 9.09056 0.0377588 9.04627 0.0421156 8.99908C0.230909 7.18837 0.840859 5.53449 1.93223 4.07518C3.582 1.87097 5.77056 0.540889 8.4979 0.110356C8.71138 0.0762326 8.92414 0.0370273 9.1369 0Z",
    fill: "#199BF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5H11V7H9V5ZM9 9H11V15H9V9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInformational);
export default __webpack_public_path__ + "static/media/ic-informational.9840f6b3667dddca49e0b2bff9f7668e.svg";
export { ForwardRef as ReactComponent };